import { LOCALES } from '../locales';

const fr = {
    [LOCALES.FRENCH]: {
        'title': 'Plaque de chaudière',
        'welcome': 'Bienvenue'
    }
}

export default fr;